import { z } from "zod";

export const inviteSchema = z
	.object({
		email: z
			.string()
			.min(1, { message: "E-mail é obrigatório" })
			.email({ message: "Digite um e-mail válido" }),
		role: z.enum(["engineer", "almoxarife", "funcionario", "cliente"], {
			message: "Selecione uma função",
		}),
		scope: z.enum(["worksite", "org"]),
	})
	.refine((data) => !(data.scope === "org" && data.role === "cliente"), {
		message: "Cliente só pode ser convidado para um canteiro",
		path: ["role"],
	});

export type InviteScope = "worksite" | "org";

export type InviteFormValues = z.infer<typeof inviteSchema>;
